export default "https://shopfront-cdn.tekoapis.com/_next/static/images/promotion_combo_en-8a61cc4bbf40babe1815b4fbb62acdfc.svg";